<script>
  import { setContext, afterUpdate } from 'svelte';
  import { getProducts, getFacets, getPages, collectionProducts, currentPage } from "./stores/collection-products-store.js";
  import { selectedFacets, appliedFacets, priceFacet } from "./stores/facet-store.js";
  import { pages } from './stores/search-pages.store.js';
  import { currentSorts } from './stores/sort-order-store.js';
  import { filterMenu } from './stores/filter-store.js';
  import CollectionHeader from "./CollectionHeader.svelte";
  import CollectionProductGrid from "./CollectionProductGrid.svelte";
  import FacetSidebar from "./FacetSidebar.svelte";
  import EmptySearchResult from './EmptySearchResult.svelte';
  import CollectionPagination from './CollectionPagination.svelte';
  import SearchPagesGrid from './SearchPagesGrid.svelte';

  export let collection;
  export let query;

  let toggleView = false;
  let loaded = false;

  setContext('collection', collection);

  function onSelectedFacetsChange() {
    if (loaded) {
      currentPage.set(1);
      getProducts($currentPage, collection, $appliedFacets, $currentSorts, $priceFacet, query);
    }
  }

  function onCurrentSortsChange() {
    if (loaded) {
      currentPage.set(1);
      getProducts($currentPage, collection, $appliedFacets, $currentSorts, $priceFacet, query);
    }
  }

  function onPriceFacetChange() {
    if (loaded) {
      currentPage.set(1);
      getProducts($currentPage, collection, $appliedFacets, $currentSorts, $priceFacet, query);
    }
  }

  function onCurrentPageChange(page) {
    if (loaded) {
      getProducts(page, collection, $appliedFacets, $currentSorts, $priceFacet, query);
    }
  }

  getFacets(collection, query);

  if(query) {
    getPages(query);
  }

  $: onSelectedFacetsChange($selectedFacets);
  $: onCurrentSortsChange($currentSorts);
  $: onPriceFacetChange($priceFacet);
  $: onCurrentPageChange($currentPage);

  afterUpdate(() => {
    // Check if this is the first load...
    if (!loaded) {
      // If so, get the products.
      getProducts($currentPage, collection, $appliedFacets, $currentSorts, $priceFacet, query);
      loaded = true;
    }
  });
</script>

<article class="spacer mt-l-mobile lg:mt-3xl">
  {#if query}
    <div class=" w-full flex items-center flex-col text-brand-blue ">
      <h1 class="text-h3-mobile lg:text-h3 font-bold uppercase mb-xl-mobile lg:mb-2xl-mobile">Search Results</h1>
      <div class="flex w-full mb-2xl lg:mb-4xl space-x-12 lg:space-x-22 justify-center">
        <button
          class={`btn uppercase text-b2-mobile lg:text-h2-mobile font-body font-normal pb-m
          ${!toggleView && 'underline underline-offset-[20px]'}`}
          on:click={() => toggleView = false}
        >
          Results
        </button>

        {#if $pages.length !== 0}
          <button
            class={`btn uppercase text-b2-mobile lg:text-h2-mobile font-body font-normal pb-m
            ${toggleView && 'underline underline-offset-[20px]'}`}
            on:click={() => toggleView = true}
          >
            Articles
          </button>
        {/if}
      </div>
    </div>
  {/if}

  {#if !toggleView}
    {#if $collectionProducts.length === 0 && query}
      <EmptySearchResult {query} />
    {:else}
      <CollectionHeader />
      
      <div class={` lg:grid ${$filterMenu ? 'grid-cols-collection' : 'grid-cols-1'} gap-4xl lg:gap-l xl:gap-4xl py-m transition-all`}>
        <FacetSidebar />
        <CollectionProductGrid />
      </div>

      <CollectionPagination />
    {/if}
  {:else}
    <SearchPagesGrid />
  {/if}

</article>
